module.exports = __webpack_public_path__ + "static/img/u-connect-reg-background.7a9f710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u-connect-reg-background.png
// module id = FTdr
// module chunks = 0